import { render, staticRenderFns } from "./archivesType.vue?vue&type=template&id=161f6ec0&scoped=true&"
import script from "./archivesType.vue?vue&type=script&lang=js&"
export * from "./archivesType.vue?vue&type=script&lang=js&"
import style0 from "./archivesType.vue?vue&type=style&index=0&id=161f6ec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f6ec0",
  null
  
)

export default component.exports